


export enum AppRoutesEnum {
	basePath = '/',
	orders = 'orders',
	customers = 'customers',
	search = 'search',
	filter = 'filter',
	
	reportingReducedOrders = 'reporting-reduced-orders',
	reportingReducedMaterials = 'reporting-reduced-materials',
	reportingRedatedOrders = 'reporting-redated-orders',
	reportingShipmentStops = 'reporting-shipment-stop',
	reportingUndeliveredOrders = 'reporting-undelivered-orders',
	
	reportingDeliveriesSummary = 'reporting-deliveries-summary',
	reportingDeliveriesTradesDc = 'reporting-deliveries-trades-dc',
	reportingDeliveriesTradesDistrict = 'reporting-deliveries-trades-district',
	reportingDeliveriesCustomer = 'reporting-deliveries-customer',
	reportingDeliveriesSku = 'reporting-deliveries-sku',
	reportingDeliveriesSkuDc = 'reporting-deliveries-sku-dc',
	reportingDeliveriesSkuDistrict = 'reporting-deliveries-sku-district',
	
	importSalesman = 'import-salesman',
	importTelesales = 'import-telesales',
	importMerchant = 'import-merchant',
	importRegionManager = 'import-region-manager',
	importLocationManager = 'import-location-manager',
}



export enum NavigateRoutesEnum {
	basePath = AppRoutesEnum.basePath,
	orders = `/${AppRoutesEnum.orders}`,
	customers = `/${AppRoutesEnum.customers}`,
	search = `/${AppRoutesEnum.search}`,
	filter = `/${AppRoutesEnum.filter}`,
	
	reportingReducedOrders = `/${AppRoutesEnum.reportingReducedOrders}`,
	reportingReducedMaterials = `/${AppRoutesEnum.reportingReducedMaterials}`,
	reportingRedatedOrders = `/${AppRoutesEnum.reportingRedatedOrders}`,
	reportingShipmentStops = `/${AppRoutesEnum.reportingShipmentStops}`,
	reportingUndeliveredOrders = `/${AppRoutesEnum.reportingUndeliveredOrders}`,
	
	reportingDeliveriesSummary = `/${AppRoutesEnum.reportingDeliveriesSummary}`,
	reportingDeliveriesTradesDc = `/${AppRoutesEnum.reportingDeliveriesTradesDc}`,
	reportingDeliveriesTradesDistrict = `/${AppRoutesEnum.reportingDeliveriesTradesDistrict}`,
	reportingDeliveriesCustomer = `/${AppRoutesEnum.reportingDeliveriesCustomer}`,
	reportingDeliveriesSku = `/${AppRoutesEnum.reportingDeliveriesSku}`,
	reportingDeliveriesSkuDc = `/${AppRoutesEnum.reportingDeliveriesSkuDc}`,
	reportingDeliveriesSkuDistrict = `/${AppRoutesEnum.reportingDeliveriesSkuDistrict}`,
	
	importSalesman = `/${AppRoutesEnum.importSalesman}`,
	importTelesales = `/${AppRoutesEnum.importTelesales}`,
	importMerchant = `/${AppRoutesEnum.importMerchant}`,
	importRegionManager = `/${AppRoutesEnum.importRegionManager}`,
	importLocationManager = `/${AppRoutesEnum.importLocationManager}`,
}